import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import InputGroup from '../../form/input-group';
import RadioGroup from '../../form/radio-group';
import LocationGroup from '../../form/location-group';
import BirthDateGroup from '../../form/birth-date-group';
import BirthTimeGroup from '../../form/birth-time-group';
import { getBirthDate, getBirthTime, diff } from '../../../util';
import { MediaQuery as MQ } from '../../../media-query';
import _ from 'underscore';
import { checkLocationData } from '../../../util';

dayjs.extend(customParseFormat);

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        props.userUpdate({
            tab: 'you',
            selected_profile: props.profiles[0],
        });

        let state = this.profileToState(props.profiles[0]);
        state.formError = null;
        state.dirty = false;

        this.state = state;
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState != this.state) {
            return true;
        }

        if (nextProps.tab != this.props.tab) {
            return true;
        }

        if (nextProps.profiles != this.props.profiles) {
            return true;
        }

        if (nextProps.profile != this.props.profile) {
            return true;
        }

        if (nextProps.submitting != this.props.submitting) {
            return true;
        }

        return false;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.profile != this.props.profile) {
            this.populateState();
        } else if (prevProps.tab != this.props.tab && this.state.formError) {
            this.populateState();
        }
    }

    /* eslint-disable max-len, complexity */
    render({ tab, profile }) {
        const disabled = tab == 'friend' && !profile;

        return (
            <profiles-form>
                {this.renderFriendMessage()}
                {this.renderNameField()}
                <row className='has-margin-10-top'>
                    <column className='is-12'>
                        <InputGroup
                            type='text'
                            name='birth_name'
                            label={!tab || tab == 'you' ? 'Birth Name:' : 'Name:'}
                            placeholder='ENTER NAME'
                            value={this.state.birth_name.value}
                            error={this.state.birth_name.error}
                            onInput={this.setFormValues}
                            disabled={disabled}
                        />
                    </column>
                </row>
                <row className='has-margin-20-bottom is-aligned-center'>
                    <column className='is-2 is-1-desktop is-3-tiny'>
                        <label>Gender:</label>
                    </column>
                    <column className='is-10 is-11-desktop is-9-tiny'>
                        <RadioGroup
                            name='gender'
                            value='female'
                            checked={this.state.gender.value == 'female'}
                            onChange={this.setFormValues}
                            label='Female'
                            disabled={disabled}
                        />
                        <RadioGroup
                            name='gender'
                            value='male'
                            checked={this.state.gender.value == 'male'}
                            onChange={this.setFormValues}
                            label='Male'
                            disabled={disabled}
                        />
                    </column>
                </row>
                <BirthDateGroup
                    name='birth_date'
                    label='Birth Date:'
                    date={this.state.birth_date}
                    month={this.state.birth_date_month}
                    day={this.state.birth_date_day}
                    year={this.state.birth_date_year}
                    onChange={this.setFormValues}
                    disabled={disabled}
                />
                <BirthTimeGroup
                    name='birth_time'
                    label='Birth Time:'
                    time={this.state.birth_time}
                    hour={this.state.birth_time_hour}
                    minute={this.state.birth_time_minute}
                    ampm={this.state.birth_time_ampm}
                    onChange={this.setFormValues}
                    disabled={disabled}
                />
                <row className='is-wrap'>
                    <column className='is-6 is-12-mobile has-padding-10-right-desktop has-padding-10-right-tablet'>
                        <LocationGroup
                            prefix='birth'
                            label='Birth'
                            onChange={this.setFormValues}
                            disabled={disabled}
                            data={this.state.birth_location}
                        />
                    </column>
                    <column className='is-6 is-12-mobile'>
                        <LocationGroup
                            prefix='current'
                            label='Current'
                            onChange={this.setFormValues}
                            disabled={disabled}
                            data={this.state.current_location}
                        />
                    </column>
                </row>
                <row>
                    <column className='is-12 has-text-center'>
                        <button
                            className={`button ${!this.state.dirty || this.props.submitting ? 'disabled' : ''}`}
                            onClick={this.validateForm}
                        >
                            {this.props.submitting ? 'SUBMITTING...' : 'SAVE PROFILE'}
                        </button>
                        {this.renderFormError()}
                        {this.renderFormSuccess()}
                    </column>
                </row>
            </profiles-form>
        );
    }
    /* eslint-enable max-len, complexity */

    renderFriendMessage = () => {
        if (this.props.tab == 'friend' && !this.props.profile) {
            return (<p className='is-message'>Please choose a Friend Profile above.</p>);
        }

        return null;
    }

    renderNameField = () => {
        if (!this.props.tab || this.props.tab == 'you') {
            return (
                <row className='has-margin-10-top has-margin--10-bottom'>
                    <column className='is-12'>
                        <InputGroup
                            type='text'
                            name='name'
                            label='What would you like us to call you?'
                            placeholder='ENTER NAME'
                            value={this.state.name.value}
                            error={this.state.name.error}
                            onInput={this.setFormValues}
                        />
                    </column>
                </row>
            );
        }

        return null;
    }

    renderFormError = () => {
        if (this.state.formError) {
            return (
                <p className='is-error has-margin-8-top'>Please check required fields above</p>
            );
        }

        return null;
    }

    renderFormSuccess = () => {
        if (this.props.success) {
            return (<p className='is-success'>Your profile has been saved!</p>);
        }

        return null;
    }

    populateState = () => {
        let state = {};

        if (this.props.profile) {
            const profile = this.props.profile;
            state = {
                formError: false,
                dirty: false,
                ...this.profileToState(profile),
            };
        } else {
            state = {
                formError: false,
                dirty: false,
                birth_name: {
                    value: '',
                    error: false,
                },
                gender: {
                    value: 'female',
                    error: false,
                },
                birth_date: {
                    value: '',
                    error: false,
                },
                birth_date_day: {
                    value: null,
                    error: false,
                },
                birth_date_month: {
                    value: null,
                    error: false,
                },
                birth_date_year: {
                    value: null,
                    error: false,
                },
                birth_location: {
                    country: {
                        value: null,
                        error: false,
                    },
                    county: {
                        value: null,
                        error: false,
                    },
                    state: {
                        value: null,
                        error: false,
                    },
                    city: {
                        value: null,
                        error: false,
                    },
                    city_id: {
                        value: null,
                    },
                },
                current_location: {
                    country: {
                        value: null,
                        error: false,
                    },
                    county: {
                        value: null,
                        error: false,
                    },
                    state: {
                        value: null,
                        error: false,
                    },
                    city: {
                        value: null,
                        error: false,
                    },
                    city_id: {
                        value: null,
                    },
                },
                birth_time: {
                    value: '',
                    error: false,
                },
                birth_time_hour: {
                    value: null,
                    error: false,
                },
                birth_time_minute: {
                    value: null,
                    error: false,
                },
                birth_time_ampm: {
                    value: 'am',
                    error: false,
                },
            };
        }

        this.setState(state);
    }

    /* eslint-disable complexity */
    setFormValues = (e) => {
        let state = [];

        if ((e.type == 'keyup' && e.key == 'Enter') || e.type == 'change' || e.type == 'input') {
            if (e.target.type && e.target.type == 'checkbox') {
                if (e.target.checked) {
                    state[e.target.name] = { value: e.target.value, error: false };
                } else {
                    state[e.target.name] = { value: null, error: false };
                }
            } else if (_.contains(['birth_location', 'current_location'], e.target.name)) {
                state[e.target.name] = e.target.value;
            } else {
                state[e.target.name] = { value: e.target.value, error: false };
            }

            if (e.target.name == 'birth_date_month') {
                const month = e.target.value;
                const day = this.state.birth_date_day.value;
                const year = this.state.birth_date_year.value;

                const birth_date = getBirthDate(month, day, year);

                state.birth_date = { value: birth_date, error: false };
            } else if (e.target.name == 'birth_date_day') {
                const month = this.state.birth_date_month.value;
                const day = e.target.value;
                const year = this.state.birth_date_year.value;

                const birth_date = getBirthDate(month, day, year);

                state.birth_date = { value: birth_date, error: false };
            } else if (e.target.name == 'birth_date_year') {
                const month = this.state.birth_date_month.value;
                const day = this.state.birth_date_day.value;
                const year = e.target.value;

                const birth_date = getBirthDate(month, day, year);

                state.birth_date = { value: birth_date, error: false };
            } else if (e.target.name == 'birth_date') {
                const birth_date = dayjs(e.target.value).format('YYYY-MM-DD');
                state.birth_date = { value: birth_date, error: false };
            } else if (e.target.name == 'birth_time_hour') {
                const hour = e.target.value;
                const minute = this.state.birth_time_minute.value;
                const ampm = this.state.birth_time_ampm.value;

                const birth_time = getBirthTime(hour, minute, ampm);

                state.birth_time = { value: birth_time, error: false };
            } else if (e.target.name == 'birth_time_minute') {
                const hour = this.state.birth_time_hour.value;
                const minute = e.target.value;
                const ampm = this.state.birth_time_ampm.value;

                const birth_time = getBirthTime(hour, minute, ampm);

                state.birth_time = { value: birth_time, error: false };
            } else if (e.target.name == 'birth_time_ampm') {
                const hour = this.state.birth_time_hour.value;
                const minute = this.state.birth_time_minute.value;
                const ampm = e.target.value;

                const birth_time = getBirthTime(hour, minute, ampm);

                state.birth_time = { value: birth_time, error: false };
            } else if (e.target.name == 'birth_time' && e.target.value == 'unknown') {
                state.birth_time_hour = {
                    value: null,
                    error: false,
                };

                state.birth_time_minute = {
                    value: null,
                    error: false,
                };
            }

            state.dirty = true;
            this.setState(state);

            if (this.props.success) {
                this.props.setSuccess(false);
            }
        }
    }

    validateForm = () => {
        let state = { formError: false };

        if (this.state.dirty) {
            if ((!this.props.tab || this.props.tab == 'you') && !this.state.name.value) {
                state.formError = true;
                state.name = {
                    value: this.state.name.value,
                    error: 'This field is required',
                };
            }

            if (!this.state.birth_name.value) {
                state.formError = true;
                state.birth_name = {
                    value: this.state.birth_name.value,
                    error: 'This field is required',
                };
            }

            if (
                !this.state.birth_date.value
                ||
                !this.state.birth_date.value.toString().match(/[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}/)
            ) {
                state.formError = true;
                state.birth_date = {
                    value: this.state.birth_date.value,
                    error: 'This field is required',
                };

                if (!MQ.isMobile()) {
                    if (!this.state.birth_date_month.value) {
                        state.birth_date_month = {
                            value: this.state.birth_date_month.value,
                            error: 'This field is required',
                        };
                    }

                    if (!this.state.birth_date_day.value) {
                        state.birth_date_day = {
                            value: this.state.birth_date_day.value,
                            error: 'This field is required',
                        };
                    }

                    if (!this.state.birth_date_year.value) {
                        state.birth_date_year = {
                            value: this.state.birth_date_year.value,
                            error: 'This field is required',
                        };
                    }
                }
            }

            state.birth_location = { ...this.state.birth_location };
            if (this.state.birth_location.country.value) {
                if (checkLocationData(this.props.location.birth_states, this.state.birth_location.state.value)) {
                    state.formError = true;
                    state.birth_location.state = {
                        value: this.state.birth_location.state.value,
                        error: 'This field is required',
                    };
                }

                if (this.props.location.birth_cities && !this.state.birth_location.city.value) {
                    state.formError = true;
                    state.birth_location.city.error = 'This field is required';
                } else if (this.props.location.birth_cities && !this.state.birth_location.city_id.value) {
                    state.formError = true;
                    state.birth_location.city.error = 'Please choose a city from the list';
                }
            }

            if (this.state.current_location.country.value) {
                state.current_location = { ...this.state.current_location };

                if (checkLocationData(this.props.location.current_states, this.state.current_location.state.value)) {
                    state.formError = true;
                    state.current_location.state = {
                        value: this.state.current_location.state.value,
                        error: 'This field is required',
                    };
                }

                if (this.props.location.current_cities && !this.state.current_location.city.value) {
                    state.formError = true;
                    state.current_location.city.error = 'This field is required';
                } else if (this.props.location.current_cities && !this.state.current_location.city_id.value) {
                    state.formError = true;
                    state.current_location.city.error = 'Please choose a city from the list';
                }
            }
        }

        if (this.state.dirty && !state.formError) {
            this.submit();
        }

        this.setState({ ...this.state, ...state });
    }
    /* eslint-enable complexity */

    submit = () => {
        let payload = {
            name: this.state.name.value || this.state.birth_name.value,
            gender: this.state.gender.value,
            person_1_birth_date: this.state.birth_date.value,
            person_1_name: {
                first: this.state.birth_name.value,
            },
            person_1_birth_location: {
                city: this.state.birth_location.city.value,
                state: this.state.birth_location.state.value,
                country: this.state.birth_location.country.value,
                city_id: this.state.birth_location.city_id.value,
            },
            person_1_location: {
                city: this.state.current_location.city.value,
                state: this.state.current_location.state.value,
                country: this.state.current_location.country.value,
                city_id: this.state.current_location.city_id.value,
            },
        };

        if (this.state.birth_time.value !== 'unknown' && this.state.birth_time.value !== null) {
            payload.person_1_birth_time = this.state.birth_time.value;
        }

        if (this.props.tab == 'new') {
            this.props.saveProfile(payload);
        } else if (this.props.tab == 'you') {
            this.props.updateProfile(payload);
        } else {
            const existing = this.profileToState(this.props.profile);
            const current = diff(existing, this.state);
            const updates = diff(this.state, existing);
            delete(updates.dirty);
            delete(updates.formError);

            this.props.userUpdate({
                profileModal: {
                    profile_uuid: this.props.profile.profile_uuid,
                    current: current,
                    updates: updates,
                    message: 'Please confirm updates<br class="is-visible-mobile" /><span class="is-hidden-mobile"> </span>to your friend profile', // eslint-disable-line max-len
                    buttonText: 'SAVE',
                    linkText: 'Keep Editing',
                    payload: payload,
                    type: 'update',
                    profile: this.props.profile,
                },
            });

            this.props.routeTo('profile');
        }
    }

    /* eslint-disable complexity */
    profileToState = (profile) => {
        const birth_date = dayjs(profile.birth_date, ['YYYY-MM-DD', null]);
        const birth_time = dayjs(profile.birth_time, 'HH:mm');

        if (profile.birth_city && profile.birth_country && !profile.birth_city_id) {
            this.props.getLocation({
                prefix: 'birth',
                city_name: profile.birth_city.toLowerCase().replace(' ', '_'),
                state_name: profile.birth_state.toLowerCase(),
                country_name: profile.birth_country.toLowerCase(),
            });
        } else if (profile.birth_city_id && !profile.birth_country_id) {
            this.props.getLocation({
                prefix: 'birth',
                city_id: profile.birth_city_id,
            });
        }

        if (profile.current_city && profile.current_country && !profile.current_city_id) {
            this.props.getLocation({
                prefix: 'current',
                city_name: profile.current_city.toLowerCase().replace(' ', '_'),
                state_name: profile.current_state.toLowerCase(),
                country_name: profile.current_country.toLowerCase(),
            });
        } else if (profile.current_city_id && !profile.current_country_id) {
            this.props.getLocation({
                prefix: 'current',
                city_id: profile.current_city_id,
            });
        }

        return {
            name: {
                value: profile.display_name || null,
                error: null,
            },
            birth_name: {
                value: profile.first_name || null,
                error: null,
            },
            gender: {
                value: profile.gender || 'female',
            },
            birth_date: {
                value: birth_date.isValid() ? birth_date.format('YYYY-MM-DD') : null,
                error: null,
            },
            birth_date_month: {
                value: birth_date.isValid() ? birth_date.format('M') : null,
                error: null,
            },
            birth_date_day: {
                value: birth_date.isValid() ? birth_date.format('D') : null,
                error: null,
            },
            birth_date_year: {
                value: birth_date.isValid() ? birth_date.format('YYYY') : null,
                error: null,
            },
            birth_time: {
                value: profile.birth_time,
                error: null,
            },
            birth_time_hour: {
                value: profile.birth_time ? birth_time.format('h') : null,
                error: null,
            },
            birth_time_minute: {
                value: profile.birth_time ? birth_time.format('mm') : null,
                error: null,
            },
            birth_time_ampm: {
                value: profile.birth_time ? birth_time.format('a') : 'am',
                error: null,
            },
            birth_location: {
                country: {
                    value: profile.birth_country_id,
                    error: false,
                },
                state: {
                    value: profile.birth_state_id,
                    error: false,
                },
                city: {
                    value: profile.birth_city,
                    error: false,
                },
                city_id: {
                    value: profile.birth_city_id,
                },
            },
            current_location: {
                country: {
                    value: profile.current_country_id,
                    error: false,
                },
                state: {
                    value: profile.current_state_id,
                    error: false,
                },
                city: {
                    value: profile.current_city,
                    error: false,
                },
                city_id: {
                    value: profile.current_city_id,
                },
            },
        };
    }
    /* eslint-enable complexity */
}

const mapStateToProps = (state) => ({
    profiles: state.user && state.user.profiles,
    profile: state.user && state.user.selected_profile,
    submitting: state.product && state.product.submitting,
    success: state.form && state.form.success,
    tab: state.user && state.user.tab,
    location: state.location,
});

const mapDispatchToProps = (dispatch) => ({
    saveProfile: (payload) => dispatch({ type: 'profile-manager:save-profile', payload: payload }),
    updateProfile: (payload) => dispatch({ type: 'profile-manager:update-profile', payload: payload }),
    userUpdate: (payload) => dispatch({ type: 'user:update', payload: payload }),
    routeTo: (payload) => dispatch({ type: 'route:to', payload: payload }),
    setSuccess: (payload) => dispatch({ type: 'form:update', payload: { success: payload } }),
    getLocation: (payload) => dispatch({ type: 'product:get-location', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
